import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { TimelineSection } from '../components/TimelineSection';
import { FAQSection } from '../components/FAQSection';
import { PricingCTA } from '../components/PricingCTA';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <main className="w-full overflow-x-hidden" data-id="element-430">
      <HeroSection data-id="element-431" />
      <PainSection data-id="element-432" />
      <SolutionSection data-id="element-433" />
      <WhatYouGetSection data-id="element-434" />
      <TimelineSection data-id="element-435" />
      <FAQSection data-id="element-436" />
      <PricingCTA data-id="element-437" />
      <FooterSection data-id="element-438" />
    </main>;
}